import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
// import * as VueGoogleMaps from "vue2-google-maps";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import vco from "v-click-outside";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

import "../src/design/app.scss";
import "video.js/dist/video-js.min.css";

import store from "@/state/store";

import App from "./App.vue";

import { initFirebaseBackend } from "./authUtils";
import i18n from "./i18n";
import QRCode from "qrcode";

import { configureFakeBackend } from "./helpers/fake-backend";

// import tinymce from "vue-tinymce-editor";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/element-variables.scss";

import utils from "./util/util";
import cookies from "./util/cookie";
import storage from "./util/storage";

Vue.prototype.utils = utils;
Vue.prototype.cookies = cookies;
Vue.prototype.$storage = storage;
Vue.prototype.$qrCode = QRCode;

// import { log } from "@/util/fun.js";
export const log = window.canDebug ? console.log : () => {};

import appListLoding from "./components/listLoading/index.js";
Vue.use(appListLoding);
import uploadButton from "./components/uploadButton/index.js";
Vue.use(uploadButton);

import TDesign from "tdesign-vue";
Vue.use(TDesign);

// 全局样式
import "./assets/style/style.scss";
//全局函数
import fun from "./util/globalFunction";
Vue.use(fun);

import axios from "axios";
// Vue.use(axios)

axios.defaults.baseURL = "/api";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

//全局查看图片详情
import img from "./components/showImg/showImg.js";
Vue.use(img);

// Vue.component("tinymce", tinymce);
Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
//     libraries: "places",
//   },
//   installComponents: true,
// });
Vue.use(ElementUI);
import SortIcon from "@/components/SortIcon.vue";
Vue.component("sort-icon", SortIcon);
Vue.component("apexchart", VueApexCharts);
import ViewNum from "./components/viewNum.vue";
Vue.component("ViewNum", ViewNum);
import pagination from "./components/pagination/pagination.vue";
Vue.component("pagination", pagination);
import contentModal from "./components/contentModal/index";
Vue.prototype.contentModal = contentModal.install;
import appVideo from "./components/appVideo/index.js";
Vue.use(appVideo);

import { el_select_loadmore } from "./util/directives.js";
Vue.directive("el-select-loadmore", el_select_loadmore);
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
